export default "__VITE_ASSET__nXXeYWzS__"